import { render, staticRenderFns } from "./BusinessView.vue?vue&type=template&id=f2e3db18&scoped=true"
import script from "./BusinessView.vue?vue&type=script&lang=js"
export * from "./BusinessView.vue?vue&type=script&lang=js"
import style0 from "./BusinessView.vue?vue&type=style&index=0&id=f2e3db18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e3db18",
  null
  
)

export default component.exports